import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Card } from '../../ui/card';
import { X, Upload } from 'lucide-react';

const ProjectModal = ({
  editingProject,
  formData,
  imagePreview,
  onClose,
  onSubmit,
  onChange,
  onImageChange,
  onImageDragOver,
  onImageDragLeave,
  onImageDrop,
  isDraggingImage,
  onRemoveImage,
}) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
    <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-2xl font-bold text-gray-800">
            {editingProject ? 'Editar Projeto' : 'Novo Projeto'}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors">
            <X className="w-6 h-6 text-gray-600" />
          </button>
        </div>
        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Título</label>
            <Input
              type="text" name="title" value={formData.title} onChange={onChange} required
              className="w-full" placeholder="Ex: Residência Familiar - Belo Horizonte"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
            <Textarea
              name="description" value={formData.description} onChange={onChange}
              required rows={3} className="w-full" placeholder="Descrição do projeto..."
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Categoria</label>
              <select
                name="category" value={formData.category} onChange={onChange} required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              >
                <option>Residencial</option><option>Comercial</option>
                <option>Industrial</option><option>Rural</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Potência</label>
              <Input
                type="text" name="power" value={formData.power} onChange={onChange}
                required className="w-full" placeholder="Ex: 8 kWp"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Imagem do Projeto</label>
            <div
              className={`block border-2 border-dashed rounded-lg p-4 text-center transition-colors ${isDraggingImage ? 'border-orange-500 bg-orange-50' : 'border-gray-300'}`}
              onDragOver={onImageDragOver}
              onDragEnter={onImageDragOver}
              onDragLeave={onImageDragLeave}
              onDrop={onImageDrop}
            >
              <input id="project-image-upload" type="file" accept="image/*" onChange={onImageChange} className="hidden" />
              {imagePreview ? (
                <div className="relative">
                  <img src={imagePreview} alt="Preview" className="w-full h-48 object-cover rounded-lg mb-2" />
                  <Button type="button" onClick={onRemoveImage} variant="outline" className="w-full">
                    Remover Imagem
                  </Button>
                </div>
              ) : (
                <label htmlFor="project-image-upload" className="block cursor-pointer">
                  <Upload className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                  <p className="text-gray-600 mb-2">Clique ou arraste uma imagem aqui</p>
                </label>
              )}
            </div>
          </div>
          <div className="flex space-x-4">
            <Button type="button" onClick={onClose} variant="outline" className="flex-1">Cancelar</Button>
            <Button type="submit" className="flex-1 bg-orange-600 hover:bg-orange-700 text-white">
              {editingProject ? 'Salvar Alterações' : 'Criar Projeto'}
            </Button>
          </div>
        </form>
      </div>
    </Card>
  </div>
);

export default ProjectModal;
